import { REGION } from '@eureka/utils/environment';
import { DeployEnv } from '@patsnap-utils/biz';

const REGION_DEFAULT_TIMEZONES: Partial<Record<DeployEnv, string>> = {
    [DeployEnv.CN]: 'Asia/Shanghai',
    [DeployEnv.US]: 'America/New_York',
    [DeployEnv.EU]: 'Europe/London',
};

let fallbackWarningLogged = false;

export function getRegionDefaultTimezone(region: DeployEnv = REGION): string {
    return REGION_DEFAULT_TIMEZONES[region] || 'Asia/Shanghai';
}

function logTimezoneFallback(region: DeployEnv, error?: unknown) {
    if (fallbackWarningLogged) return;
    fallbackWarningLogged = true;
    console.warn('[Timezone] Browser timezone unavailable; using regional default.', {
        region,
        fallback: getRegionDefaultTimezone(region),
        error,
    });
}

export function getClientTimezone(region: DeployEnv = REGION): string {
    try {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone?.trim();
        if (timezone) return timezone;
    } catch (error) {
        logTimezoneFallback(region, error);
        return getRegionDefaultTimezone(region);
    }
    logTimezoneFallback(region);
    return getRegionDefaultTimezone(region);
}
